import React, { FC } from 'react';
import { Table } from 'react-bootstrap';

interface PropTypes {
  body: any;
  head?: string;
}

export const SearchResultTable: FC<PropTypes> = ({ body, head }) => {

  return <Table bordered hover size="sm" className="mw-100" variant="light">
    {head &&
      <thead>
      <tr>
        <th className="bg-dark-subtle">{head}</th>
      </tr>
      </thead>
    }
    <tbody>
    {body}
    </tbody>
  </Table>;
};
